import { Component, OnInit } from '@angular/core';
import { Route, Router, RouterLink, Routes } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from '../../../../services/auth.service';
import { LocalStorageService } from '../../../../Shared/common/local-storage.service';
import { MessageServiceService } from '../../../../Shared/common/message-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { LoginapiService } from '../services/loginapi.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-login',
  imports: [NgxSpinnerModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})

export class LoginComponent implements OnInit {
  centralUserID: any;

  constructor(private toastr: ToastrService, private authService: AuthService, private lsService: LocalStorageService, private router: Router, private oauthService: OAuthService, private msgService: MessageServiceService,
    private spinner: NgxSpinnerService, private loginService: LoginapiService
 ) {

  
  }
  ngOnInit(): void  {
    //this.navigatetocharity();
    debugger
    this.spinner.show();
    const storedValue = sessionStorage.getItem('id_token_claims_obj');

   
    if (storedValue)
    {
      var email = JSON.parse(storedValue);
    }
    debugger
    if (email)
    {
        var email = email.emails[0]
        this.logIn(email);              // for azure
      }
    }
  logIn(email: string) {
    debugger 
    this.authService.logIn(email)
      .subscribe((res) => {
        debugger
        if (res.status == 0) {
          //Navigate to to the page based on returnUrl
          if (res.entity != null) {
            this.lsService.setCurrentUser(res.entity[0]);
            this.authService.currentUserSubject.next(res.entity[0]);
            this.lsService.setCentralUserID(res.entity[0].centralUserID);
            this.lsService.setUserID(res.entity[0].userID);

            this.authService.checkUserLicenseDetails();
            localStorage.setItem("userID", res.entity[0].userID.toString());
            localStorage.setItem("CentralUserId", res.entity[0].centralUserID.toString());
            const currentUser = localStorage.getItem('currentUser');
            if (currentUser) {
              const parsedUser = JSON.parse(currentUser);
              this.centralUserID = parsedUser.userID;

            }
            if (this.centralUserID) {
              this.loginService.GetCharityGrid(this.centralUserID).subscribe((data: any) => {
                localStorage.setItem("UserRecords", data);
                document.body.classList.add('loggedIn');
                if (data > 0) {
                  this.router.navigate(['/charity']);
                  document.body.classList.add('records');
                } else {
                  this.router.navigate(['/landingpage']);
                  document.body.classList.add('norecords');
                }
                //this.router.navigate(['/landingpage']);
              })
            }
      

          }

        }
      })

      
  }
  navigatetocharity() {
    const currentUser = localStorage.getItem('userID');
    if (currentUser) {
      //const parsedUser = JSON.parse(currentUser);
      //this.centralUserID = parsedUser.centralUserID;
      this.centralUserID = +currentUser
    }
    if (this.centralUserID) {
      this.loginService.GetCharityGrid(this.centralUserID).subscribe((data: any) => {
        if (data > 0) {
          this.router.navigate(['/charity']);
        } else {
          this.router.navigate(['/landingPage']);
        }
      })
    }

  }
}
